/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Activity,
  ActivityReply,
  Answerer,
  GenQCandidate,
  GetActivityRepliesUnreadStatus200ResponseInner,
  GetAuthVerify200Response,
  GetCsrfToken200Response,
  GetHello200Response,
  GetMemories200Response,
  GetMemoryMemoryIdResponseStatus200Response,
  LINEAccountLinkURL,
  Memory,
  NewAnswerer,
  NewComment,
  NewTodo,
  PatchLiffActivityReplyActivityReplyIdRequest,
  PatchLiffMemoryMemoryIdRequest,
  PatchUserQuestionIdRequest,
  PatchUsersMeAnswerersAnswererIdRequest,
  PostAuthPasswordResetRequest,
  PostAuthSendPasswordResetEmailRequest,
  PostAuthSigninRequest,
  PostAuthSignup201Response,
  PostAuthSignupRequest,
  PostLiffAccountLinkLineEndpoint201Response,
  PostLiffAccountLinkLineEndpoint403Response,
  PostLiffAccountLinkLineEndpoint500Response,
  PostLiffAccountLinkLineEndpointRequest,
  PostLiffMemoryAnswerImage200Response,
  PostLiffMemoryUploadVideoRequest,
  PostLiffMemoryVoiceSignedurl200Response,
  PostLiffMemoryVoiceSignedurlRequest,
  PostLiffSignedurlUploadVideo200Response,
  PostLiffSignedurlUploadVideoRequest,
  PostLiffStoryRequest,
  PostLiffVideoCompleteMultiPartUploadRequest,
  PostLiffVideoMultiPartUploadSignedurl200Response,
  PostLiffVideoMultiPartUploadSignedurlRequest,
  PostLiffWellnessCheckAnswerRequest,
  PostLineAccountLinkOneTimePassword201Response,
  PostLineAccountLinkOneTimePasswordRequest,
  PostLineMemoryUploadVoiceRequest,
  PostMemoryCommentImagesSignedurl200ResponseInner,
  PostMemoryCommentImagesSignedurlRequest,
  PostMemoryVoiceSignedurl200Response,
  PostMemoryVoiceSignedurlRequest,
  PostStoryRequest,
  PostUserQuestionRequest,
  PostUsersMeAnswererUploadProfileImage200Response,
  PostVideoCompleteMultiPartUploadRequest,
  PostVideoMultiPartUploadSignedurl200Response,
  PostVideoMultiPartUploadSignedurlRequest,
  Story,
  Todo,
  User,
  UserQuestion,
  WellnessCheck,
} from '../models';
import {
    ActivityFromJSON,
    ActivityToJSON,
    ActivityReplyFromJSON,
    ActivityReplyToJSON,
    AnswererFromJSON,
    AnswererToJSON,
    GenQCandidateFromJSON,
    GenQCandidateToJSON,
    GetActivityRepliesUnreadStatus200ResponseInnerFromJSON,
    GetActivityRepliesUnreadStatus200ResponseInnerToJSON,
    GetAuthVerify200ResponseFromJSON,
    GetAuthVerify200ResponseToJSON,
    GetCsrfToken200ResponseFromJSON,
    GetCsrfToken200ResponseToJSON,
    GetHello200ResponseFromJSON,
    GetHello200ResponseToJSON,
    GetMemories200ResponseFromJSON,
    GetMemories200ResponseToJSON,
    GetMemoryMemoryIdResponseStatus200ResponseFromJSON,
    GetMemoryMemoryIdResponseStatus200ResponseToJSON,
    LINEAccountLinkURLFromJSON,
    LINEAccountLinkURLToJSON,
    MemoryFromJSON,
    MemoryToJSON,
    NewAnswererFromJSON,
    NewAnswererToJSON,
    NewCommentFromJSON,
    NewCommentToJSON,
    NewTodoFromJSON,
    NewTodoToJSON,
    PatchLiffActivityReplyActivityReplyIdRequestFromJSON,
    PatchLiffActivityReplyActivityReplyIdRequestToJSON,
    PatchLiffMemoryMemoryIdRequestFromJSON,
    PatchLiffMemoryMemoryIdRequestToJSON,
    PatchUserQuestionIdRequestFromJSON,
    PatchUserQuestionIdRequestToJSON,
    PatchUsersMeAnswerersAnswererIdRequestFromJSON,
    PatchUsersMeAnswerersAnswererIdRequestToJSON,
    PostAuthPasswordResetRequestFromJSON,
    PostAuthPasswordResetRequestToJSON,
    PostAuthSendPasswordResetEmailRequestFromJSON,
    PostAuthSendPasswordResetEmailRequestToJSON,
    PostAuthSigninRequestFromJSON,
    PostAuthSigninRequestToJSON,
    PostAuthSignup201ResponseFromJSON,
    PostAuthSignup201ResponseToJSON,
    PostAuthSignupRequestFromJSON,
    PostAuthSignupRequestToJSON,
    PostLiffAccountLinkLineEndpoint201ResponseFromJSON,
    PostLiffAccountLinkLineEndpoint201ResponseToJSON,
    PostLiffAccountLinkLineEndpoint403ResponseFromJSON,
    PostLiffAccountLinkLineEndpoint403ResponseToJSON,
    PostLiffAccountLinkLineEndpoint500ResponseFromJSON,
    PostLiffAccountLinkLineEndpoint500ResponseToJSON,
    PostLiffAccountLinkLineEndpointRequestFromJSON,
    PostLiffAccountLinkLineEndpointRequestToJSON,
    PostLiffMemoryAnswerImage200ResponseFromJSON,
    PostLiffMemoryAnswerImage200ResponseToJSON,
    PostLiffMemoryUploadVideoRequestFromJSON,
    PostLiffMemoryUploadVideoRequestToJSON,
    PostLiffMemoryVoiceSignedurl200ResponseFromJSON,
    PostLiffMemoryVoiceSignedurl200ResponseToJSON,
    PostLiffMemoryVoiceSignedurlRequestFromJSON,
    PostLiffMemoryVoiceSignedurlRequestToJSON,
    PostLiffSignedurlUploadVideo200ResponseFromJSON,
    PostLiffSignedurlUploadVideo200ResponseToJSON,
    PostLiffSignedurlUploadVideoRequestFromJSON,
    PostLiffSignedurlUploadVideoRequestToJSON,
    PostLiffStoryRequestFromJSON,
    PostLiffStoryRequestToJSON,
    PostLiffVideoCompleteMultiPartUploadRequestFromJSON,
    PostLiffVideoCompleteMultiPartUploadRequestToJSON,
    PostLiffVideoMultiPartUploadSignedurl200ResponseFromJSON,
    PostLiffVideoMultiPartUploadSignedurl200ResponseToJSON,
    PostLiffVideoMultiPartUploadSignedurlRequestFromJSON,
    PostLiffVideoMultiPartUploadSignedurlRequestToJSON,
    PostLiffWellnessCheckAnswerRequestFromJSON,
    PostLiffWellnessCheckAnswerRequestToJSON,
    PostLineAccountLinkOneTimePassword201ResponseFromJSON,
    PostLineAccountLinkOneTimePassword201ResponseToJSON,
    PostLineAccountLinkOneTimePasswordRequestFromJSON,
    PostLineAccountLinkOneTimePasswordRequestToJSON,
    PostLineMemoryUploadVoiceRequestFromJSON,
    PostLineMemoryUploadVoiceRequestToJSON,
    PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON,
    PostMemoryCommentImagesSignedurl200ResponseInnerToJSON,
    PostMemoryCommentImagesSignedurlRequestFromJSON,
    PostMemoryCommentImagesSignedurlRequestToJSON,
    PostMemoryVoiceSignedurl200ResponseFromJSON,
    PostMemoryVoiceSignedurl200ResponseToJSON,
    PostMemoryVoiceSignedurlRequestFromJSON,
    PostMemoryVoiceSignedurlRequestToJSON,
    PostStoryRequestFromJSON,
    PostStoryRequestToJSON,
    PostUserQuestionRequestFromJSON,
    PostUserQuestionRequestToJSON,
    PostUsersMeAnswererUploadProfileImage200ResponseFromJSON,
    PostUsersMeAnswererUploadProfileImage200ResponseToJSON,
    PostVideoCompleteMultiPartUploadRequestFromJSON,
    PostVideoCompleteMultiPartUploadRequestToJSON,
    PostVideoMultiPartUploadSignedurl200ResponseFromJSON,
    PostVideoMultiPartUploadSignedurl200ResponseToJSON,
    PostVideoMultiPartUploadSignedurlRequestFromJSON,
    PostVideoMultiPartUploadSignedurlRequestToJSON,
    StoryFromJSON,
    StoryToJSON,
    TodoFromJSON,
    TodoToJSON,
    UserFromJSON,
    UserToJSON,
    UserQuestionFromJSON,
    UserQuestionToJSON,
    WellnessCheckFromJSON,
    WellnessCheckToJSON,
} from '../models';

export interface DeleteMemoryMemoryIdFavoriteRequest {
    memoryId: string;
}

export interface DeleteUserQuestionIdRequest {
    id: string;
}

export interface GetActivityIdActivityRepliesRequest {
    id: string;
}

export interface GetActivityReplyIdRequest {
    id: string;
}

export interface GetLiffActivityReplyIdRequest {
    id: string;
}

export interface GetLiffAnswererRequest {
    oneTimePassword: string;
}

export interface GetLiffAnswererAnswererIdRequest {
    answererId: string;
}

export interface GetLiffMemoryMemoryIdRequest {
    memoryId: string;
}

export interface GetLiffWellnessCheckWellnessCheckIdRequest {
    wellnessCheckId: string;
}

export interface GetMemoriesRequest {
    limit: number;
    nextPageToken?: string;
}

export interface GetMemoryMemoryIdRequest {
    memoryId: string;
}

export interface GetMemoryMemoryIdResponseStatusRequest {
    memoryId: string;
}

export interface GetStoryRequest {
    id: string;
}

export interface GetTodosRequest {
    userId: string;
}

export interface GetUserQuestionIdRequest {
    id: string;
}

export interface GetUserQuestionsAnswererIdRequest {
    answererId: string;
}

export interface GetUsersMeAnswerersAnswererIdRequest {
    answererId: string;
}

export interface GetUsersMeChangeEmailConfirmRequest {
    code: string;
}

export interface GetWellnessCheckRequest {
    id: string;
}

export interface GetWellnessChecksRequest {
    answererId: string;
}

export interface PatchActivityReplyActivityReplyIdCommentRequest {
    activityReplyId: string;
    newComment?: NewComment;
}

export interface PatchActivityReplyIdLastWatchedAtRequest {
    id: string;
}

export interface PatchLiffActivityReplyActivityReplyIdOperationRequest {
    activityReplyId: string;
    patchLiffActivityReplyActivityReplyIdRequest?: PatchLiffActivityReplyActivityReplyIdRequest;
}

export interface PatchLiffActivityReplyActivityReplyIdCommentRequest {
    activityReplyId: string;
    newComment?: NewComment;
}

export interface PatchLiffMemoryMemoryIdOperationRequest {
    memoryId: string;
    patchLiffMemoryMemoryIdRequest?: PatchLiffMemoryMemoryIdRequest;
}

export interface PatchLiffMemoryMemoryIdResponseStatusRequest {
    memoryId: string;
}

export interface PatchMemoryMemoryIdLikedCountRequest {
    memoryId: string;
}

export interface PatchMemoryMemoryIdResponseStatusRequest {
    memoryId: string;
}

export interface PatchUserQuestionIdOperationRequest {
    id: string;
    patchUserQuestionIdRequest?: PatchUserQuestionIdRequest;
}

export interface PatchUsersMeAnswerersAnswererIdOperationRequest {
    answererId: string;
    patchUsersMeAnswerersAnswererIdRequest?: PatchUsersMeAnswerersAnswererIdRequest;
}

export interface PatchWellnessChecksIdLastWatchedAtRequest {
    id: string;
}

export interface PostActivityReplyCommentImagesSignedurlRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostAuthEmailVerifyRequest {
    clientId: string;
    userName: string;
    confirmationCode: string;
    redirectUri: string;
}

export interface PostAuthPasswordResetOperationRequest {
    postAuthPasswordResetRequest?: PostAuthPasswordResetRequest;
}

export interface PostAuthSendPasswordResetEmailOperationRequest {
    postAuthSendPasswordResetEmailRequest?: PostAuthSendPasswordResetEmailRequest;
}

export interface PostAuthSigninOperationRequest {
    postAuthSigninRequest?: PostAuthSigninRequest;
}

export interface PostAuthSignupOperationRequest {
    postAuthSignupRequest?: PostAuthSignupRequest;
}

export interface PostLiffAccountLinkLineEndpointOperationRequest {
    postLiffAccountLinkLineEndpointRequest?: PostLiffAccountLinkLineEndpointRequest;
}

export interface PostLiffActivityReplyCommentImageSignedurlRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostLiffActivityReplyImageSignedurlRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostLiffAnswererUploadProfileImageRequest {
    answererProfileImageByLiff: Blob;
    answererId: string;
}

export interface PostLiffMemoryAnswerImageRequest {
    memoryImageFile: Blob;
}

export interface PostLiffMemoryAnswerImageSignedurlRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostLiffMemoryCommentImagesSignedurlRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostLiffMemoryMemoryIdCommentsRequest {
    memoryId: string;
    newComment?: NewComment;
}

export interface PostLiffMemoryUploadVideoOperationRequest {
    postLiffMemoryUploadVideoRequest?: PostLiffMemoryUploadVideoRequest;
}

export interface PostLiffMemoryVoiceSignedurlOperationRequest {
    postLiffMemoryVoiceSignedurlRequest?: PostLiffMemoryVoiceSignedurlRequest;
}

export interface PostLiffSignedurlUploadVideoOperationRequest {
    postLiffSignedurlUploadVideoRequest?: PostLiffSignedurlUploadVideoRequest;
}

export interface PostLiffStoryOperationRequest {
    postLiffStoryRequest?: PostLiffStoryRequest;
}

export interface PostLiffVideoCompleteMultiPartUploadOperationRequest {
    postLiffVideoCompleteMultiPartUploadRequest?: PostLiffVideoCompleteMultiPartUploadRequest;
}

export interface PostLiffVideoMultiPartUploadSignedurlOperationRequest {
    postLiffVideoMultiPartUploadSignedurlRequest?: PostLiffVideoMultiPartUploadSignedurlRequest;
}

export interface PostLiffWellnessCheckAnswerOperationRequest {
    postLiffWellnessCheckAnswerRequest?: PostLiffWellnessCheckAnswerRequest;
}

export interface PostLineAccountLinkOneTimePasswordOperationRequest {
    postLineAccountLinkOneTimePasswordRequest?: PostLineAccountLinkOneTimePasswordRequest;
}

export interface PostLineMemoryUploadVoiceOperationRequest {
    postLineMemoryUploadVoiceRequest?: PostLineMemoryUploadVoiceRequest;
}

export interface PostMemoryCommentImagesSignedurlOperationRequest {
    postMemoryCommentImagesSignedurlRequest?: PostMemoryCommentImagesSignedurlRequest;
}

export interface PostMemoryMemoryIdCommentsRequest {
    memoryId: string;
    newComment?: NewComment;
}

export interface PostMemoryMemoryIdFavoriteRequest {
    memoryId: string;
}

export interface PostMemoryVoiceSignedurlOperationRequest {
    postMemoryVoiceSignedurlRequest?: PostMemoryVoiceSignedurlRequest;
}

export interface PostStoryOperationRequest {
    postStoryRequest?: PostStoryRequest;
}

export interface PostStoryAnswererIdRequest {
    answererId: string;
    postStoryRequest?: PostStoryRequest;
}

export interface PostTodosRequest {
    newTodo?: NewTodo;
}

export interface PostUserQuestionOperationRequest {
    postUserQuestionRequest?: PostUserQuestionRequest;
}

export interface PostUsersMeAnswererUploadProfileImageRequest {
    answererProfileImage: Blob;
    answererId: string;
}

export interface PostUsersMeAnswerersRequest {
    newAnswerer?: NewAnswerer;
}

export interface PostUsersMeAnswerersAnswererIdVerifyEmailRequest {
    answererId: string;
}

export interface PostUsersMeChangeEmailRequest {
    postAuthSendPasswordResetEmailRequest?: PostAuthSendPasswordResetEmailRequest;
}

export interface PostUsersMeQandaRequest {
    answererId: string;
    sendDate: string;
}

export interface PostUsersMeUploadProfileImageRequest {
    meProfileImage: Blob;
}

export interface PostVideoCompleteMultiPartUploadOperationRequest {
    postVideoCompleteMultiPartUploadRequest?: PostVideoCompleteMultiPartUploadRequest;
}

export interface PostVideoMultiPartUploadSignedurlOperationRequest {
    postVideoMultiPartUploadSignedurlRequest?: PostVideoMultiPartUploadSignedurlRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * 
     */
    async deleteMemoryMemoryIdFavoriteRaw(requestParameters: DeleteMemoryMemoryIdFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling deleteMemoryMemoryIdFavorite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}/favorite`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteMemoryMemoryIdFavorite(requestParameters: DeleteMemoryMemoryIdFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMemoryMemoryIdFavoriteRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async deleteUserQuestionIdRaw(requestParameters: DeleteUserQuestionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserQuestionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-question/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteUserQuestionId(requestParameters: DeleteUserQuestionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserQuestionIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getActivitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Activity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityFromJSON));
    }

    /**
     */
    async getActivities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Activity>> {
        const response = await this.getActivitiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * get activity replies of activity
     * 
     */
    async getActivityIdActivityRepliesRaw(requestParameters: GetActivityIdActivityRepliesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActivityReply>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getActivityIdActivityReplies.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activity/{id}/activity-replies`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityReplyFromJSON));
    }

    /**
     * get activity replies of activity
     * 
     */
    async getActivityIdActivityReplies(requestParameters: GetActivityIdActivityRepliesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActivityReply>> {
        const response = await this.getActivityIdActivityRepliesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ActivityReplies Unread Status
     */
    async getActivityRepliesUnreadStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetActivityRepliesUnreadStatus200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activity-replies/unread-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetActivityRepliesUnreadStatus200ResponseInnerFromJSON));
    }

    /**
     * Get ActivityReplies Unread Status
     */
    async getActivityRepliesUnreadStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetActivityRepliesUnreadStatus200ResponseInner>> {
        const response = await this.getActivityRepliesUnreadStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * get activity reply  
     * 
     */
    async getActivityReplyIdRaw(requestParameters: GetActivityReplyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityReply>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getActivityReplyId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activity-reply/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityReplyFromJSON(jsonValue));
    }

    /**
     * get activity reply  
     * 
     */
    async getActivityReplyId(requestParameters: GetActivityReplyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityReply> {
        const response = await this.getActivityReplyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getAuthVerifyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAuthVerify200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/verify`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAuthVerify200ResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getAuthVerify(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAuthVerify200Response> {
        const response = await this.getAuthVerifyRaw(initOverrides);
        return await response.value();
    }

    /**
     * get csrf token
     */
    async getCsrfTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCsrfToken200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csrf-token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCsrfToken200ResponseFromJSON(jsonValue));
    }

    /**
     * get csrf token
     */
    async getCsrfToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCsrfToken200Response> {
        const response = await this.getCsrfTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * get all generated Question candidate by user
     * get generated q candidate authenticated user
     */
    async getGenQcandidateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GenQCandidate>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/generatedQCandidate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GenQCandidateFromJSON));
    }

    /**
     * get all generated Question candidate by user
     * get generated q candidate authenticated user
     */
    async getGenQcandidate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GenQCandidate>> {
        const response = await this.getGenQcandidateRaw(initOverrides);
        return await response.value();
    }

    /**
     * hello world
     */
    async getHelloRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHello200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hello`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHello200ResponseFromJSON(jsonValue));
    }

    /**
     * hello world
     */
    async getHello(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHello200Response> {
        const response = await this.getHelloRaw(initOverrides);
        return await response.value();
    }

    /**
     * get activity reply for liff
     * 
     */
    async getLiffActivityReplyIdRaw(requestParameters: GetLiffActivityReplyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityReply>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLiffActivityReplyId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/activity-reply/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityReplyFromJSON(jsonValue));
    }

    /**
     * get activity reply for liff
     * 
     */
    async getLiffActivityReplyId(requestParameters: GetLiffActivityReplyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityReply> {
        const response = await this.getLiffActivityReplyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * get-answerer
     */
    async getLiffAnswererRaw(requestParameters: GetLiffAnswererRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answerer>> {
        if (requestParameters.oneTimePassword === null || requestParameters.oneTimePassword === undefined) {
            throw new runtime.RequiredError('oneTimePassword','Required parameter requestParameters.oneTimePassword was null or undefined when calling getLiffAnswerer.');
        }

        const queryParameters: any = {};

        if (requestParameters.oneTimePassword !== undefined) {
            queryParameters['oneTimePassword'] = requestParameters.oneTimePassword;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/answerer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswererFromJSON(jsonValue));
    }

    /**
     * 
     * get-answerer
     */
    async getLiffAnswerer(requestParameters: GetLiffAnswererRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answerer> {
        const response = await this.getLiffAnswererRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get answerer for liff
     */
    async getLiffAnswererAnswererIdRaw(requestParameters: GetLiffAnswererAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answerer>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling getLiffAnswererAnswererId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/answerer/{answererId}`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswererFromJSON(jsonValue));
    }

    /**
     * get answerer for liff
     */
    async getLiffAnswererAnswererId(requestParameters: GetLiffAnswererAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answerer> {
        const response = await this.getLiffAnswererAnswererIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * get answerers
     */
    async getLiffAnswerersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Answerer>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/answerers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnswererFromJSON));
    }

    /**
     * 
     * get answerers
     */
    async getLiffAnswerers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Answerer>> {
        const response = await this.getLiffAnswerersRaw(initOverrides);
        return await response.value();
    }

    /**
     * get a memory for liff
     * get a memory for liff
     */
    async getLiffMemoryMemoryIdRaw(requestParameters: GetLiffMemoryMemoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling getLiffMemoryMemoryId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/memory/{memoryId}`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * get a memory for liff
     * get a memory for liff
     */
    async getLiffMemoryMemoryId(requestParameters: GetLiffMemoryMemoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.getLiffMemoryMemoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get a wellnessCheck for liff
     * Your GET endpoint
     */
    async getLiffWellnessCheckWellnessCheckIdRaw(requestParameters: GetLiffWellnessCheckWellnessCheckIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WellnessCheck>> {
        if (requestParameters.wellnessCheckId === null || requestParameters.wellnessCheckId === undefined) {
            throw new runtime.RequiredError('wellnessCheckId','Required parameter requestParameters.wellnessCheckId was null or undefined when calling getLiffWellnessCheckWellnessCheckId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/wellnessCheck/{wellnessCheckId}`.replace(`{${"wellnessCheckId"}}`, encodeURIComponent(String(requestParameters.wellnessCheckId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WellnessCheckFromJSON(jsonValue));
    }

    /**
     * get a wellnessCheck for liff
     * Your GET endpoint
     */
    async getLiffWellnessCheckWellnessCheckId(requestParameters: GetLiffWellnessCheckWellnessCheckIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WellnessCheck> {
        const response = await this.getLiffWellnessCheckWellnessCheckIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get pagenation answerer\'s memories
     * Your GET endpoint
     */
    async getMemoriesRaw(requestParameters: GetMemoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMemories200Response>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling getMemories.');
        }

        const queryParameters: any = {};

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMemories200ResponseFromJSON(jsonValue));
    }

    /**
     * get pagenation answerer\'s memories
     * Your GET endpoint
     */
    async getMemories(requestParameters: GetMemoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMemories200Response> {
        const response = await this.getMemoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get pagenation favorite memories
     * Your GET endpoint
     */
    async getMemoriesFavoritesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Memory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memories/favorites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MemoryFromJSON));
    }

    /**
     * get pagenation favorite memories
     * Your GET endpoint
     */
    async getMemoriesFavorites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Memory>> {
        const response = await this.getMemoriesFavoritesRaw(initOverrides);
        return await response.value();
    }

    /**
     * get memory
     * get Memory
     */
    async getMemoryMemoryIdRaw(requestParameters: GetMemoryMemoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling getMemoryMemoryId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * get memory
     * get Memory
     */
    async getMemoryMemoryId(requestParameters: GetMemoryMemoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.getMemoryMemoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get responseStatus on Memory
     * get responseStatus on Memory
     */
    async getMemoryMemoryIdResponseStatusRaw(requestParameters: GetMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMemoryMemoryIdResponseStatus200Response>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling getMemoryMemoryIdResponseStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}/responseStatus`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMemoryMemoryIdResponseStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * get responseStatus on Memory
     * get responseStatus on Memory
     */
    async getMemoryMemoryIdResponseStatus(requestParameters: GetMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMemoryMemoryIdResponseStatus200Response> {
        const response = await this.getMemoryMemoryIdResponseStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Story>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoryFromJSON));
    }

    /**
     */
    async getStories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Story>> {
        const response = await this.getStoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getStoryRaw(requestParameters: GetStoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Story>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getStory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/stories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoryFromJSON(jsonValue));
    }

    /**
     * 
     */
    async getStory(requestParameters: GetStoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Story> {
        const response = await this.getStoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTodosRaw(requestParameters: GetTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Todo>>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getTodos.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/todos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TodoFromJSON));
    }

    /**
     * Your GET endpoint
     */
    async getTodos(requestParameters: GetTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Todo>> {
        const response = await this.getTodosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 
     */
    async getUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * 
     * 
     */
    async getUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getUserQuestionIdRaw(requestParameters: GetUserQuestionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserQuestion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUserQuestionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-question/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserQuestionFromJSON(jsonValue));
    }

    /**
     * 
     */
    async getUserQuestionId(requestParameters: GetUserQuestionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserQuestion> {
        const response = await this.getUserQuestionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getUserQuestionsAnswererIdRaw(requestParameters: GetUserQuestionsAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserQuestion>>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling getUserQuestionsAnswererId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-questions/{answererId}`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserQuestionFromJSON));
    }

    /**
     * Your GET endpoint
     */
    async getUserQuestionsAnswererId(requestParameters: GetUserQuestionsAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserQuestion>> {
        const response = await this.getUserQuestionsAnswererIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get your answerers
     */
    async getUsersMeAnswerersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Answerer>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/answerers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnswererFromJSON));
    }

    /**
     * get your answerers
     */
    async getUsersMeAnswerers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Answerer>> {
        const response = await this.getUsersMeAnswerersRaw(initOverrides);
        return await response.value();
    }

    /**
     * get your answerer
     * get your answerer
     */
    async getUsersMeAnswerersAnswererIdRaw(requestParameters: GetUsersMeAnswerersAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answerer>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling getUsersMeAnswerersAnswererId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/answerers/{answererId}`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswererFromJSON(jsonValue));
    }

    /**
     * get your answerer
     * get your answerer
     */
    async getUsersMeAnswerersAnswererId(requestParameters: GetUsersMeAnswerersAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answerer> {
        const response = await this.getUsersMeAnswerersAnswererIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * change email confirm
     */
    async getUsersMeChangeEmailConfirmRaw(requestParameters: GetUsersMeChangeEmailConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAuthSignup201Response>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUsersMeChangeEmailConfirm.');
        }

        const queryParameters: any = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/change-email-confirm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAuthSignup201ResponseFromJSON(jsonValue));
    }

    /**
     * change email confirm
     */
    async getUsersMeChangeEmailConfirm(requestParameters: GetUsersMeChangeEmailConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAuthSignup201Response> {
        const response = await this.getUsersMeChangeEmailConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getWellnessCheckRaw(requestParameters: GetWellnessCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WellnessCheck>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getWellnessCheck.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/wellness-checks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WellnessCheckFromJSON(jsonValue));
    }

    /**
     * 
     */
    async getWellnessCheck(requestParameters: GetWellnessCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WellnessCheck> {
        const response = await this.getWellnessCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getWellnessChecksRaw(requestParameters: GetWellnessChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WellnessCheck>>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling getWellnessChecks.');
        }

        const queryParameters: any = {};

        if (requestParameters.answererId !== undefined) {
            queryParameters['answererId'] = requestParameters.answererId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/wellness-checks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WellnessCheckFromJSON));
    }

    /**
     * 
     */
    async getWellnessChecks(requestParameters: GetWellnessChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WellnessCheck>> {
        const response = await this.getWellnessChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get allWellnessCheck byUserId
     * 
     */
    async getWellnessChecksAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WellnessCheck>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/all-wellness-checks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WellnessCheckFromJSON));
    }

    /**
     * get allWellnessCheck byUserId
     * 
     */
    async getWellnessChecksAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WellnessCheck>> {
        const response = await this.getWellnessChecksAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * add activity reply comment
     */
    async patchActivityReplyActivityReplyIdCommentRaw(requestParameters: PatchActivityReplyActivityReplyIdCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityReply>> {
        if (requestParameters.activityReplyId === null || requestParameters.activityReplyId === undefined) {
            throw new runtime.RequiredError('activityReplyId','Required parameter requestParameters.activityReplyId was null or undefined when calling patchActivityReplyActivityReplyIdComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/activity-reply/{activityReplyId}/comment`.replace(`{${"activityReplyId"}}`, encodeURIComponent(String(requestParameters.activityReplyId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NewCommentToJSON(requestParameters.newComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityReplyFromJSON(jsonValue));
    }

    /**
     * add activity reply comment
     */
    async patchActivityReplyActivityReplyIdComment(requestParameters: PatchActivityReplyActivityReplyIdCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityReply> {
        const response = await this.patchActivityReplyActivityReplyIdCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update lastWatchedAt
     * 
     */
    async patchActivityReplyIdLastWatchedAtRaw(requestParameters: PatchActivityReplyIdLastWatchedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityReply>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchActivityReplyIdLastWatchedAt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/activity-reply/{id}/last-watched-at`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityReplyFromJSON(jsonValue));
    }

    /**
     * update lastWatchedAt
     * 
     */
    async patchActivityReplyIdLastWatchedAt(requestParameters: PatchActivityReplyIdLastWatchedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityReply> {
        const response = await this.patchActivityReplyIdLastWatchedAtRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * reply activity for liff
     */
    async patchLiffActivityReplyActivityReplyIdRaw(requestParameters: PatchLiffActivityReplyActivityReplyIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.activityReplyId === null || requestParameters.activityReplyId === undefined) {
            throw new runtime.RequiredError('activityReplyId','Required parameter requestParameters.activityReplyId was null or undefined when calling patchLiffActivityReplyActivityReplyId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/activity-reply/{activityReplyId}`.replace(`{${"activityReplyId"}}`, encodeURIComponent(String(requestParameters.activityReplyId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchLiffActivityReplyActivityReplyIdRequestToJSON(requestParameters.patchLiffActivityReplyActivityReplyIdRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * reply activity for liff
     */
    async patchLiffActivityReplyActivityReplyId(requestParameters: PatchLiffActivityReplyActivityReplyIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchLiffActivityReplyActivityReplyIdRaw(requestParameters, initOverrides);
    }

    /**
     * add activity reply comment
     */
    async patchLiffActivityReplyActivityReplyIdCommentRaw(requestParameters: PatchLiffActivityReplyActivityReplyIdCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityReply>> {
        if (requestParameters.activityReplyId === null || requestParameters.activityReplyId === undefined) {
            throw new runtime.RequiredError('activityReplyId','Required parameter requestParameters.activityReplyId was null or undefined when calling patchLiffActivityReplyActivityReplyIdComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/activity-reply/{activityReplyId}/comment`.replace(`{${"activityReplyId"}}`, encodeURIComponent(String(requestParameters.activityReplyId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NewCommentToJSON(requestParameters.newComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityReplyFromJSON(jsonValue));
    }

    /**
     * add activity reply comment
     */
    async patchLiffActivityReplyActivityReplyIdComment(requestParameters: PatchLiffActivityReplyActivityReplyIdCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityReply> {
        const response = await this.patchLiffActivityReplyActivityReplyIdCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * answer memory for liff
     */
    async patchLiffMemoryMemoryIdRaw(requestParameters: PatchLiffMemoryMemoryIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling patchLiffMemoryMemoryId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/{memoryId}`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchLiffMemoryMemoryIdRequestToJSON(requestParameters.patchLiffMemoryMemoryIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * answer memory for liff
     */
    async patchLiffMemoryMemoryId(requestParameters: PatchLiffMemoryMemoryIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.patchLiffMemoryMemoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async patchLiffMemoryMemoryIdResponseStatusRaw(requestParameters: PatchLiffMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling patchLiffMemoryMemoryIdResponseStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/liff/memory/{memoryId}/responseStatus`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async patchLiffMemoryMemoryIdResponseStatus(requestParameters: PatchLiffMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchLiffMemoryMemoryIdResponseStatusRaw(requestParameters, initOverrides);
    }

    /**
     * increment likedCount
     */
    async patchMemoryMemoryIdLikedCountRaw(requestParameters: PatchMemoryMemoryIdLikedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling patchMemoryMemoryIdLikedCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}/likedCount`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * increment likedCount
     */
    async patchMemoryMemoryIdLikedCount(requestParameters: PatchMemoryMemoryIdLikedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.patchMemoryMemoryIdLikedCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Make memory\'responseStatus NO_ANSWER 
     * Make memory-responseStatus NO_ANSWER
     */
    async patchMemoryMemoryIdResponseStatusRaw(requestParameters: PatchMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling patchMemoryMemoryIdResponseStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}/responseStatus`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Make memory\'responseStatus NO_ANSWER 
     * Make memory-responseStatus NO_ANSWER
     */
    async patchMemoryMemoryIdResponseStatus(requestParameters: PatchMemoryMemoryIdResponseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchMemoryMemoryIdResponseStatusRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async patchUserQuestionIdRaw(requestParameters: PatchUserQuestionIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserQuestion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchUserQuestionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-question/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchUserQuestionIdRequestToJSON(requestParameters.patchUserQuestionIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserQuestionFromJSON(jsonValue));
    }

    /**
     * 
     */
    async patchUserQuestionId(requestParameters: PatchUserQuestionIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserQuestion> {
        const response = await this.patchUserQuestionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update answerer
     * update answerer
     */
    async patchUsersMeAnswerersAnswererIdRaw(requestParameters: PatchUsersMeAnswerersAnswererIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answerer>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling patchUsersMeAnswerersAnswererId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/me/answerers/{answererId}`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchUsersMeAnswerersAnswererIdRequestToJSON(requestParameters.patchUsersMeAnswerersAnswererIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswererFromJSON(jsonValue));
    }

    /**
     * update answerer
     * update answerer
     */
    async patchUsersMeAnswerersAnswererId(requestParameters: PatchUsersMeAnswerersAnswererIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answerer> {
        const response = await this.patchUsersMeAnswerersAnswererIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update lastWatchedAt
     * 
     */
    async patchWellnessChecksIdLastWatchedAtRaw(requestParameters: PatchWellnessChecksIdLastWatchedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WellnessCheck>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchWellnessChecksIdLastWatchedAt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/wellness-checks/{id}/last-watched-at`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WellnessCheckFromJSON(jsonValue));
    }

    /**
     * update lastWatchedAt
     * 
     */
    async patchWellnessChecksIdLastWatchedAt(requestParameters: PatchWellnessChecksIdLastWatchedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WellnessCheck> {
        const response = await this.patchWellnessChecksIdLastWatchedAtRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postActivityReplyCommentImagesSignedurlRaw(requestParameters: PostActivityReplyCommentImagesSignedurlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/activity-reply/comment/images/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * 
     */
    async postActivityReplyCommentImagesSignedurl(requestParameters: PostActivityReplyCommentImagesSignedurlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postActivityReplyCommentImagesSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * verify email
     */
    async postAuthEmailVerifyRaw(requestParameters: PostAuthEmailVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling postAuthEmailVerify.');
        }

        if (requestParameters.userName === null || requestParameters.userName === undefined) {
            throw new runtime.RequiredError('userName','Required parameter requestParameters.userName was null or undefined when calling postAuthEmailVerify.');
        }

        if (requestParameters.confirmationCode === null || requestParameters.confirmationCode === undefined) {
            throw new runtime.RequiredError('confirmationCode','Required parameter requestParameters.confirmationCode was null or undefined when calling postAuthEmailVerify.');
        }

        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
            throw new runtime.RequiredError('redirectUri','Required parameter requestParameters.redirectUri was null or undefined when calling postAuthEmailVerify.');
        }

        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['client_id'] = requestParameters.clientId;
        }

        if (requestParameters.userName !== undefined) {
            queryParameters['user_name'] = requestParameters.userName;
        }

        if (requestParameters.confirmationCode !== undefined) {
            queryParameters['confirmation_code'] = requestParameters.confirmationCode;
        }

        if (requestParameters.redirectUri !== undefined) {
            queryParameters['redirect_uri'] = requestParameters.redirectUri;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/verify-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * verify email
     */
    async postAuthEmailVerify(requestParameters: PostAuthEmailVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postAuthEmailVerifyRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async postAuthPasswordResetRaw(requestParameters: PostAuthPasswordResetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/password-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthPasswordResetRequestToJSON(requestParameters.postAuthPasswordResetRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async postAuthPasswordReset(requestParameters: PostAuthPasswordResetOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postAuthPasswordResetRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * 
     */
    async postAuthSendPasswordResetEmailRaw(requestParameters: PostAuthSendPasswordResetEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/send-password-reset-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthSendPasswordResetEmailRequestToJSON(requestParameters.postAuthSendPasswordResetEmailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * 
     */
    async postAuthSendPasswordResetEmail(requestParameters: PostAuthSendPasswordResetEmailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postAuthSendPasswordResetEmailRaw(requestParameters, initOverrides);
    }

    /**
     * signin
     */
    async postAuthSigninRaw(requestParameters: PostAuthSigninOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAuthSignup201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/signin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthSigninRequestToJSON(requestParameters.postAuthSigninRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAuthSignup201ResponseFromJSON(jsonValue));
    }

    /**
     * signin
     */
    async postAuthSignin(requestParameters: PostAuthSigninOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAuthSignup201Response> {
        const response = await this.postAuthSigninRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * signout
     */
    async postAuthSignoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAuthSignup201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/signout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAuthSignup201ResponseFromJSON(jsonValue));
    }

    /**
     * signout
     */
    async postAuthSignout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAuthSignup201Response> {
        const response = await this.postAuthSignoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * Signup
     */
    async postAuthSignupRaw(requestParameters: PostAuthSignupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAuthSignup201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthSignupRequestToJSON(requestParameters.postAuthSignupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAuthSignup201ResponseFromJSON(jsonValue));
    }

    /**
     * Signup
     */
    async postAuthSignup(requestParameters: PostAuthSignupOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAuthSignup201Response> {
        const response = await this.postAuthSignupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postHelloRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHello200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hello`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHello200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postHello(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHello200Response> {
        const response = await this.postHelloRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffAccountLinkLineEndpointRaw(requestParameters: PostLiffAccountLinkLineEndpointOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LINEAccountLinkURL>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/account-link/line-endpoint`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffAccountLinkLineEndpointRequestToJSON(requestParameters.postLiffAccountLinkLineEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LINEAccountLinkURLFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffAccountLinkLineEndpoint(requestParameters: PostLiffAccountLinkLineEndpointOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LINEAccountLinkURL> {
        const response = await this.postLiffAccountLinkLineEndpointRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffActivityReplyCommentImageSignedurlRaw(requestParameters: PostLiffActivityReplyCommentImageSignedurlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/activity-reply/comment/image/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * 
     */
    async postLiffActivityReplyCommentImageSignedurl(requestParameters: PostLiffActivityReplyCommentImageSignedurlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postLiffActivityReplyCommentImageSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffActivityReplyImageSignedurlRaw(requestParameters: PostLiffActivityReplyImageSignedurlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/activity-reply/image/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * 
     */
    async postLiffActivityReplyImageSignedurl(requestParameters: PostLiffActivityReplyImageSignedurlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postLiffActivityReplyImageSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffAnswererUploadProfileImageRaw(requestParameters: PostLiffAnswererUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLiffSignedurlUploadVideoRequest>> {
        if (requestParameters.answererProfileImageByLiff === null || requestParameters.answererProfileImageByLiff === undefined) {
            throw new runtime.RequiredError('answererProfileImageByLiff','Required parameter requestParameters.answererProfileImageByLiff was null or undefined when calling postLiffAnswererUploadProfileImage.');
        }

        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling postLiffAnswererUploadProfileImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.answererProfileImageByLiff !== undefined) {
            formParams.append('answererProfileImageByLiff', requestParameters.answererProfileImageByLiff as any);
        }

        if (requestParameters.answererId !== undefined) {
            formParams.append('answererId', requestParameters.answererId as any);
        }

        const response = await this.request({
            path: `/liff/answerer/upload-profile-image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLiffSignedurlUploadVideoRequestFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffAnswererUploadProfileImage(requestParameters: PostLiffAnswererUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLiffSignedurlUploadVideoRequest> {
        const response = await this.postLiffAnswererUploadProfileImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * answer memory image for liff
     */
    async postLiffMemoryAnswerImageRaw(requestParameters: PostLiffMemoryAnswerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLiffMemoryAnswerImage200Response>> {
        if (requestParameters.memoryImageFile === null || requestParameters.memoryImageFile === undefined) {
            throw new runtime.RequiredError('memoryImageFile','Required parameter requestParameters.memoryImageFile was null or undefined when calling postLiffMemoryAnswerImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.memoryImageFile !== undefined) {
            formParams.append('memoryImageFile', requestParameters.memoryImageFile as any);
        }

        const response = await this.request({
            path: `/liff/memory/answer/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLiffMemoryAnswerImage200ResponseFromJSON(jsonValue));
    }

    /**
     * answer memory image for liff
     */
    async postLiffMemoryAnswerImage(requestParameters: PostLiffMemoryAnswerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLiffMemoryAnswerImage200Response> {
        const response = await this.postLiffMemoryAnswerImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * answer memory image signedurl for liff
     */
    async postLiffMemoryAnswerImageSignedurlRaw(requestParameters: PostLiffMemoryAnswerImageSignedurlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/answer/image/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * answer memory image signedurl for liff
     */
    async postLiffMemoryAnswerImageSignedurl(requestParameters: PostLiffMemoryAnswerImageSignedurlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postLiffMemoryAnswerImageSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 
     */
    async postLiffMemoryCommentImagesSignedurlRaw(requestParameters: PostLiffMemoryCommentImagesSignedurlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/comment-images/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * 
     * 
     */
    async postLiffMemoryCommentImagesSignedurl(requestParameters: PostLiffMemoryCommentImagesSignedurlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postLiffMemoryCommentImagesSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffMemoryMemoryIdCommentsRaw(requestParameters: PostLiffMemoryMemoryIdCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling postLiffMemoryMemoryIdComments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/{memoryId}/comments`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCommentToJSON(requestParameters.newComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffMemoryMemoryIdComments(requestParameters: PostLiffMemoryMemoryIdCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.postLiffMemoryMemoryIdCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffMemoryUploadVideoRaw(requestParameters: PostLiffMemoryUploadVideoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/upload/video`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffMemoryUploadVideoRequestToJSON(requestParameters.postLiffMemoryUploadVideoRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async postLiffMemoryUploadVideo(requestParameters: PostLiffMemoryUploadVideoOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postLiffMemoryUploadVideoRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async postLiffMemoryVoiceSignedurlRaw(requestParameters: PostLiffMemoryVoiceSignedurlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLiffMemoryVoiceSignedurl200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/voice/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffMemoryVoiceSignedurlRequestToJSON(requestParameters.postLiffMemoryVoiceSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLiffMemoryVoiceSignedurl200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffMemoryVoiceSignedurl(requestParameters: PostLiffMemoryVoiceSignedurlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLiffMemoryVoiceSignedurl200Response> {
        const response = await this.postLiffMemoryVoiceSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffSignedurlUploadVideoRaw(requestParameters: PostLiffSignedurlUploadVideoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLiffSignedurlUploadVideo200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/signedurl/upload/video`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffSignedurlUploadVideoRequestToJSON(requestParameters.postLiffSignedurlUploadVideoRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLiffSignedurlUploadVideo200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffSignedurlUploadVideo(requestParameters: PostLiffSignedurlUploadVideoOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLiffSignedurlUploadVideo200Response> {
        const response = await this.postLiffSignedurlUploadVideoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLiffStoryRaw(requestParameters: PostLiffStoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Story>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/story`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffStoryRequestToJSON(requestParameters.postLiffStoryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoryFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLiffStory(requestParameters: PostLiffStoryOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Story> {
        const response = await this.postLiffStoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Video Complete Multi Part Upload
     */
    async postLiffVideoCompleteMultiPartUploadRaw(requestParameters: PostLiffVideoCompleteMultiPartUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/video/complete-multi-part-upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffVideoCompleteMultiPartUploadRequestToJSON(requestParameters.postLiffVideoCompleteMultiPartUploadRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Video Complete Multi Part Upload
     */
    async postLiffVideoCompleteMultiPartUpload(requestParameters: PostLiffVideoCompleteMultiPartUploadOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postLiffVideoCompleteMultiPartUploadRaw(requestParameters, initOverrides);
    }

    /**
     * Video Multi Part Upload For Liff
     */
    async postLiffVideoMultiPartUploadSignedurlRaw(requestParameters: PostLiffVideoMultiPartUploadSignedurlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLiffVideoMultiPartUploadSignedurl200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/video/multi-part-upload-signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffVideoMultiPartUploadSignedurlRequestToJSON(requestParameters.postLiffVideoMultiPartUploadSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLiffVideoMultiPartUploadSignedurl200ResponseFromJSON(jsonValue));
    }

    /**
     * Video Multi Part Upload For Liff
     */
    async postLiffVideoMultiPartUploadSignedurl(requestParameters: PostLiffVideoMultiPartUploadSignedurlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLiffVideoMultiPartUploadSignedurl200Response> {
        const response = await this.postLiffVideoMultiPartUploadSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * wellnessCheckQuestion is Answer
     * 
     */
    async postLiffWellnessCheckAnswerRaw(requestParameters: PostLiffWellnessCheckAnswerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WellnessCheck>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/wellnessCheck/answer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLiffWellnessCheckAnswerRequestToJSON(requestParameters.postLiffWellnessCheckAnswerRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WellnessCheckFromJSON(jsonValue));
    }

    /**
     * wellnessCheckQuestion is Answer
     * 
     */
    async postLiffWellnessCheckAnswer(requestParameters: PostLiffWellnessCheckAnswerOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WellnessCheck> {
        const response = await this.postLiffWellnessCheckAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLineAccountLinkOneTimePasswordRaw(requestParameters: PostLineAccountLinkOneTimePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLineAccountLinkOneTimePassword201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/line/account-link/one-time-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLineAccountLinkOneTimePasswordRequestToJSON(requestParameters.postLineAccountLinkOneTimePasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLineAccountLinkOneTimePassword201ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postLineAccountLinkOneTimePassword(requestParameters: PostLineAccountLinkOneTimePasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLineAccountLinkOneTimePassword201Response> {
        const response = await this.postLineAccountLinkOneTimePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postLineMemoryUploadVoiceRaw(requestParameters: PostLineMemoryUploadVoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/liff/memory/upload/voice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLineMemoryUploadVoiceRequestToJSON(requestParameters.postLineMemoryUploadVoiceRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async postLineMemoryUploadVoice(requestParameters: PostLineMemoryUploadVoiceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postLineMemoryUploadVoiceRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async postMemoryCommentImagesSignedurlRaw(requestParameters: PostMemoryCommentImagesSignedurlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostMemoryCommentImagesSignedurl200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/memory/comment-images/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryCommentImagesSignedurlRequestToJSON(requestParameters.postMemoryCommentImagesSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON));
    }

    /**
     * 
     */
    async postMemoryCommentImagesSignedurl(requestParameters: PostMemoryCommentImagesSignedurlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostMemoryCommentImagesSignedurl200ResponseInner>> {
        const response = await this.postMemoryCommentImagesSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * add comment on memory
     */
    async postMemoryMemoryIdCommentsRaw(requestParameters: PostMemoryMemoryIdCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling postMemoryMemoryIdComments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/memory/{memoryId}/comments`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCommentToJSON(requestParameters.newComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * add comment on memory
     */
    async postMemoryMemoryIdComments(requestParameters: PostMemoryMemoryIdCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.postMemoryMemoryIdCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postMemoryMemoryIdFavoriteRaw(requestParameters: PostMemoryMemoryIdFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.memoryId === null || requestParameters.memoryId === undefined) {
            throw new runtime.RequiredError('memoryId','Required parameter requestParameters.memoryId was null or undefined when calling postMemoryMemoryIdFavorite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/memory/{memoryId}/favorite`.replace(`{${"memoryId"}}`, encodeURIComponent(String(requestParameters.memoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async postMemoryMemoryIdFavorite(requestParameters: PostMemoryMemoryIdFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postMemoryMemoryIdFavoriteRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async postMemoryVoiceSignedurlRaw(requestParameters: PostMemoryVoiceSignedurlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostMemoryVoiceSignedurl200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/memory/voice/signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostMemoryVoiceSignedurlRequestToJSON(requestParameters.postMemoryVoiceSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostMemoryVoiceSignedurl200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postMemoryVoiceSignedurl(requestParameters: PostMemoryVoiceSignedurlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostMemoryVoiceSignedurl200Response> {
        const response = await this.postMemoryVoiceSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postStoryRaw(requestParameters: PostStoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Story>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/story`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostStoryRequestToJSON(requestParameters.postStoryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoryFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postStory(requestParameters: PostStoryOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Story> {
        const response = await this.postStoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postStoryAnswererIdRaw(requestParameters: PostStoryAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Story>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling postStoryAnswererId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/story/{answererId}`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostStoryRequestToJSON(requestParameters.postStoryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoryFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postStoryAnswererId(requestParameters: PostStoryAnswererIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Story> {
        const response = await this.postStoryAnswererIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postTodosRaw(requestParameters: PostTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/todos`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewTodoToJSON(requestParameters.newTodo),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     */
    async postTodos(requestParameters: PostTodosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postTodosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postUserQuestionRaw(requestParameters: PostUserQuestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserQuestion>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-question`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostUserQuestionRequestToJSON(requestParameters.postUserQuestionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserQuestionFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postUserQuestion(requestParameters: PostUserQuestionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserQuestion> {
        const response = await this.postUserQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * upload to answerer image
     * upload to answerer image
     */
    async postUsersMeAnswererUploadProfileImageRaw(requestParameters: PostUsersMeAnswererUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostUsersMeAnswererUploadProfileImage200Response>> {
        if (requestParameters.answererProfileImage === null || requestParameters.answererProfileImage === undefined) {
            throw new runtime.RequiredError('answererProfileImage','Required parameter requestParameters.answererProfileImage was null or undefined when calling postUsersMeAnswererUploadProfileImage.');
        }

        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling postUsersMeAnswererUploadProfileImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.answererProfileImage !== undefined) {
            formParams.append('answererProfileImage', requestParameters.answererProfileImage as any);
        }

        if (requestParameters.answererId !== undefined) {
            formParams.append('answererId', requestParameters.answererId as any);
        }

        const response = await this.request({
            path: `/users/me/answerer/upload-profile-image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostUsersMeAnswererUploadProfileImage200ResponseFromJSON(jsonValue));
    }

    /**
     * upload to answerer image
     * upload to answerer image
     */
    async postUsersMeAnswererUploadProfileImage(requestParameters: PostUsersMeAnswererUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostUsersMeAnswererUploadProfileImage200Response> {
        const response = await this.postUsersMeAnswererUploadProfileImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * register answerer
     */
    async postUsersMeAnswerersRaw(requestParameters: PostUsersMeAnswerersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answerer>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/me/answerers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewAnswererToJSON(requestParameters.newAnswerer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswererFromJSON(jsonValue));
    }

    /**
     * 
     * register answerer
     */
    async postUsersMeAnswerers(requestParameters: PostUsersMeAnswerersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answerer> {
        const response = await this.postUsersMeAnswerersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * validate Answerer\'s email address.
     * 
     */
    async postUsersMeAnswerersAnswererIdVerifyEmailRaw(requestParameters: PostUsersMeAnswerersAnswererIdVerifyEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling postUsersMeAnswerersAnswererIdVerifyEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/answerers/{answererId}/verify-email`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * validate Answerer\'s email address.
     * 
     */
    async postUsersMeAnswerersAnswererIdVerifyEmail(requestParameters: PostUsersMeAnswerersAnswererIdVerifyEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUsersMeAnswerersAnswererIdVerifyEmailRaw(requestParameters, initOverrides);
    }

    /**
     * change email
     */
    async postUsersMeChangeEmailRaw(requestParameters: PostUsersMeChangeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAuthSignup201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/me/change-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAuthSendPasswordResetEmailRequestToJSON(requestParameters.postAuthSendPasswordResetEmailRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAuthSignup201ResponseFromJSON(jsonValue));
    }

    /**
     * change email
     */
    async postUsersMeChangeEmail(requestParameters: PostUsersMeChangeEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAuthSignup201Response> {
        const response = await this.postUsersMeChangeEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update lastAccessedDatetime
     * update lastAccessedDatetime
     */
    async postUsersMeLastAccessedDatetimeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/lastAccessedDatetime`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update lastAccessedDatetime
     * update lastAccessedDatetime
     */
    async postUsersMeLastAccessedDatetime(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUsersMeLastAccessedDatetimeRaw(initOverrides);
    }

    /**
     * 
     * like QandA
     */
    async postUsersMeQandaRaw(requestParameters: PostUsersMeQandaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Memory>> {
        if (requestParameters.answererId === null || requestParameters.answererId === undefined) {
            throw new runtime.RequiredError('answererId','Required parameter requestParameters.answererId was null or undefined when calling postUsersMeQanda.');
        }

        if (requestParameters.sendDate === null || requestParameters.sendDate === undefined) {
            throw new runtime.RequiredError('sendDate','Required parameter requestParameters.sendDate was null or undefined when calling postUsersMeQanda.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me/qanda/{answererId}/{sendDate}/like`.replace(`{${"answererId"}}`, encodeURIComponent(String(requestParameters.answererId))).replace(`{${"sendDate"}}`, encodeURIComponent(String(requestParameters.sendDate))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemoryFromJSON(jsonValue));
    }

    /**
     * 
     * like QandA
     */
    async postUsersMeQanda(requestParameters: PostUsersMeQandaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Memory> {
        const response = await this.postUsersMeQandaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * user profile image upload
     * 
     */
    async postUsersMeUploadProfileImageRaw(requestParameters: PostUsersMeUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostUsersMeAnswererUploadProfileImage200Response>> {
        if (requestParameters.meProfileImage === null || requestParameters.meProfileImage === undefined) {
            throw new runtime.RequiredError('meProfileImage','Required parameter requestParameters.meProfileImage was null or undefined when calling postUsersMeUploadProfileImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.meProfileImage !== undefined) {
            formParams.append('meProfileImage', requestParameters.meProfileImage as any);
        }

        const response = await this.request({
            path: `/users/me/upload-profile-image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostUsersMeAnswererUploadProfileImage200ResponseFromJSON(jsonValue));
    }

    /**
     * user profile image upload
     * 
     */
    async postUsersMeUploadProfileImage(requestParameters: PostUsersMeUploadProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostUsersMeAnswererUploadProfileImage200Response> {
        const response = await this.postUsersMeUploadProfileImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postVideoCompleteMultiPartUploadRaw(requestParameters: PostVideoCompleteMultiPartUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/video/complete-multi-part-upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostVideoCompleteMultiPartUploadRequestToJSON(requestParameters.postVideoCompleteMultiPartUploadRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async postVideoCompleteMultiPartUpload(requestParameters: PostVideoCompleteMultiPartUploadOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postVideoCompleteMultiPartUploadRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async postVideoMultiPartUploadSignedurlRaw(requestParameters: PostVideoMultiPartUploadSignedurlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostVideoMultiPartUploadSignedurl200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/video/multi-part-upload-signedurl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostVideoMultiPartUploadSignedurlRequestToJSON(requestParameters.postVideoMultiPartUploadSignedurlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostVideoMultiPartUploadSignedurl200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async postVideoMultiPartUploadSignedurl(requestParameters: PostVideoMultiPartUploadSignedurlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostVideoMultiPartUploadSignedurl200Response> {
        const response = await this.postVideoMultiPartUploadSignedurlRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
